module.exports = __webpack_public_path__ + "media/images/web/landings/students/s6-1a274a3a1c06788d6a92dd04f9f59083.jpg";